import { render, staticRenderFns } from "./StoreDescription.vue?vue&type=template&id=05c79516&"
import script from "./StoreDescription.vue?vue&type=script&lang=js&"
export * from "./StoreDescription.vue?vue&type=script&lang=js&"
import style0 from "./StoreDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports